import { call, put, takeEvery } from 'redux-saga/effects'
import { AsyncAction } from 'src/utils/reduxUtils'
import { FetchOptOutProducts } from 'src/constants/actionTypes'
import { ApiService, callClientSecureApi } from './api/callApi'
import { Endpoints } from 'src/constants/endpoints'
import { OptOutProduct } from 'src/interfaces/optOut'
import { captureSentryError } from 'src/utils/sentry'

interface FetchOptOutProductsRequest {
  stepId: string
  productId: string
}

function* onFetchOptOutProducts(action: AsyncAction<FetchOptOutProductsRequest, OptOutProduct>) {
  try {
    const { payload }: { payload: OptOutProduct } = yield call(
      callClientSecureApi,
      Endpoints.FetchOptOutProducts,
      {
        method: 'GET',
        apiService: ApiService.Paraworks,
        params: [
          {
            value: action.payload.stepId,
            field: ':collectDataStepId',
          },
          {
            value: action.payload.productId,
            field: ':insurancePolicyProductId',
          },
        ],
      },
    )

    yield put(FetchOptOutProducts.success())

    if (action.next) {
      action.next(null, payload)
    }
  } catch (err: any) {
    captureSentryError(err, {
      message: '[saga.optOut.onFetchOptOutProducts] error',
    })

    const errorMessage = err?.payload?.message || 'Failed to fetch insurance policy products'

    yield put(FetchOptOutProducts.failed(err))

    if (action.next) {
      action.next(errorMessage)
    }
  }
}

export function* optOutSaga() {
  yield takeEvery(FetchOptOutProducts.type.REQUEST, onFetchOptOutProducts)
}
